import React from "react";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import LineItems from "./LineItems";
import withListData from "./withListData";
import HeaderData from "./HeaderData";
import HeaderImage from "./InvoiceHeaders/HeaderImage";
import FooterImage from "./InvoiceHeaders/FooterImage";

import { convertUTCToLocal, getStyle, LAYOUT_COMPONENTS_MAP } from "services/util";
import { CreditAdvice } from "./InvoiceCreditNoteDocument";

const BulkCreditNoteDocument = ({
  item,
  settings,
  organisation,
  taxRates,
  history,
  contacts,
  t,
  qrCodes,
  ...props
}) => {

  const defaultLayoutSettings = settings?.invoice_layout_settings?.find(x => x.is_default === true)

  let Header = LAYOUT_COMPONENTS_MAP[defaultLayoutSettings?.layout] || LAYOUT_COMPONENTS_MAP.default

  let baseStyle = { fontSize: (defaultLayoutSettings?.font_size || settings?.font_size_base || 16) + 'px' }

  const headerLogoStyle = getStyle(defaultLayoutSettings?.header_logo_style)
  const footerLogoStyle = getStyle(defaultLayoutSettings?.footer_logo_style)
  const invoiceLogoStyle = getStyle(defaultLayoutSettings?.invoice_logo_style)
  const invoiceTitleStyle = getStyle(defaultLayoutSettings?.invoice_title_style)
  const invoiceLabelStyle = getStyle(defaultLayoutSettings?.invoice_label_style)
  const invoiceContentStyle = getStyle(defaultLayoutSettings?.invoice_content_style)
  const lineItemHeaderStyle = getStyle(defaultLayoutSettings?.line_item_header_style)
  const lineItemStyle = getStyle(defaultLayoutSettings?.line_item_style)
  const subtotalLineStyle = getStyle(defaultLayoutSettings?.subtotal_line_style)
  const taxLineStyle = getStyle(defaultLayoutSettings?.tax_line_style)
  const totalLineStyle = getStyle(defaultLayoutSettings?.total_line_style)

  if (defaultLayoutSettings) {
    if (defaultLayoutSettings?.font_family) {
      baseStyle = { ...baseStyle, fontFamily: defaultLayoutSettings?.font_family }
    }

    if (defaultLayoutSettings?.font_color) {
      baseStyle = { ...baseStyle, color: defaultLayoutSettings?.font_color }
    }

    if (footerLogoStyle) {
      if (footerLogoStyle?.display !== 'none' && footerLogoStyle?.height && defaultLayoutSettings?.footer_logo) {
        baseStyle = { ...baseStyle, paddingBottom: footerLogoStyle?.height }
      }
    }

  }

  return (
    <DocumentRenderer {...props}>
      {item?.map((creditNote, index) => {
        const isTaxed = (creditNote.DocumentType === "standard");
        const doc_name = creditNote.DocumentType === "standard" ? "Taxed Credit Note" : "Simplified Credit Note";
        const contact = contacts?.find((contact) => contact?.ContactID === creditNote?.Contact?.ContactID)
        return (
          <div className={`container-fluid my-3`} style={{ ...baseStyle, position: 'relative', }} >
            <HeaderImage value={defaultLayoutSettings?.header_logo} invoiceLogoStyle={headerLogoStyle} />
            <Header
              item={creditNote}
              company={organisation}
              client={contact}
              taxRates={taxRates}
              t={t}
              settings={settings}
              doc_name={doc_name}
              hideAttention={true}
              logo={settings?.logo}
              taxed={isTaxed}
              qrCode={qrCodes[index]}
              defaultLayoutSettings={defaultLayoutSettings}
              invoiceLogoStyle={invoiceLogoStyle}
              invoiceTitleStyle={invoiceTitleStyle}
              invoiceLabelStyle={invoiceLabelStyle}
              invoiceContentStyle={invoiceContentStyle}
            >
              <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Date" value={creditNote.DateString} />
              <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Time" value={convertUTCToLocal(creditNote.UpdatedDateUTC)} />
              <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Number" value={creditNote.CreditNoteNumber} />
              <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Reference" value={creditNote.Reference} />
              <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Invoice Number" value={creditNote.Allocations?.length ? creditNote.Allocations[0].Invoice?.InvoiceNumber : creditNote.AllocationInvoice} />
              <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Supply Date" value={creditNote.ExpectedPaymentDateString?.substr(0, 10)} />
              <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Reason" value={creditNote.Reason} />
              {creditNote.Status === 'VOIDED' && <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Status" value={'Voided (from Xero)'} />}
            </Header>

            <LineItems
              invoice={creditNote}
              taxRates={taxRates}
              history={history}
              organisation={organisation}
              includeDiscount
              lang={props?.language}
              lineItemHeaderStyle={lineItemHeaderStyle}
              lineItemStyle={lineItemStyle}
              subtotalLineStyle={subtotalLineStyle}
              taxLineStyle={taxLineStyle}
              totalLineStyle={totalLineStyle}
            />
            <CreditAdvice item={creditNote} contact={contact} />
            <div className="font-weight-bold mt-3 mb-2">
              <Trans>Due Date: </Trans> {creditNote.DueDateString}
            </div>
            {settings?.footer ? (
              <div style={{ whiteSpace: "pre-line" }} className="mt-1">
                {settings?.footer}
              </div>
            ) : null}
            {settings?.footer_english ? (
              <div style={{ whiteSpace: "pre-line" }} className="mt-1 ltr" dir="ltr">
                {settings?.footer_english}
              </div>
            ) : null}
            <FooterImage value={defaultLayoutSettings?.footer_logo} invoiceLogoStyle={footerLogoStyle} />
            <div className={index < item?.length - 1 ? 'break-after' : ''}></div>
          </div>
        )
      }
      )}
    </DocumentRenderer >
  )
};

export default withListData(BulkCreditNoteDocument);
